import DataTableV2 from "components/commons/data-table/data-table-v2";
import React from "react";

const StationList = ({ ...props }) => {
  return <DataTableV2 {...props} />;
};

export default StationList;
